// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Nm-z","tupacHeader":"Om-z","tupacHeader2":"Pm-z","tupacMenu":"Qm-z","tupacMenu2":"Rm-z","tupacMain":"Sm-z","tupacMain2":"Tm-z"};